import chatFidexaImg from "@/assets/chat-fidexa.png";
import { PublicRoutes, blogClusterPath } from "@/constants/routes";
import { Heading, Text } from "@/design-system";
import { Link } from "react-router";
import { PageSection } from "@/pages/landingPage/components/pageSection";

// Link em texto corrido: brand-700 sobre ds-paper dá 7,06:1 (DESIGN.md §11.4).
const inlineLink =
  "text-ds-brand-700 hover:text-ds-brand-800 rounded-ds-sm font-semibold underline underline-offset-2 focus-visible:ring-2 focus-visible:ring-ds-focus focus-visible:ring-offset-2 focus-visible:outline-none";

export const NetworkSection = () => (
  <PageSection labelledBy="rede-title">
    <div className="grid items-center gap-10 lg:grid-cols-2 lg:gap-16">
      <img
        src={chatFidexaImg}
        alt="Tela do chat da Fidexa: lista de clientes à esquerda e, à direita, uma conversa de cobrança no WhatsApp com pagamento por Pix"
        width={1360}
        height={824}
        className="h-auto w-full"
        loading="lazy"
      />

      <div className="flex flex-col gap-5">
        <Heading level={2} id="rede-title">
          Feito para redes de 4 a 20 lojas
        </Heading>
        <Text size="lead" tone="muted">
          Cobrar várias unidades com planilhas e celulares separados é caro e
          arriscado. A Fidexa centraliza a{" "}
          <strong className="text-ds-ink-900 font-semibold">
            cobrança via WhatsApp de todas as lojas
          </strong>{" "}
          em um só painel, com visão por unidade e a mesma régua para a rede
          inteira.
        </Text>
        <Text size="lead" tone="muted">
          É a forma mais simples de reduzir a inadimplência do seu{" "}
          <Link to={PublicRoutes.CREDIARIO} className={inlineLink}>
            sistema de crediário próprio
          </Link>{" "}
          sem aumentar o time financeiro.
        </Text>
        <Text size="lead" tone="muted">
          Quer desenhar a régua do lembrete antes do vencimento até a cobrança
          do atraso?{" "}
          <Link
            to={blogClusterPath("regua-de-cobranca")}
            className={inlineLink}
          >
            Veja o guia de régua de cobrança
          </Link>
          .
        </Text>
      </div>
    </div>
  </PageSection>
);
